import { render, staticRenderFns } from "./ProductLabelCreate.vue?vue&type=template&id=57133df0&"
import script from "./ProductLabelCreate.vue?vue&type=script&lang=js&"
export * from "./ProductLabelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports